export default "__VITE_ASSET__CmYeua7u__"